import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'app-button1',
  standalone: true,
  imports: [],
  templateUrl: './button1.component.html',
  styleUrl: './button1.component.scss'
})
export class Button1Component {
  @Input() buttonText!: string;

  
}
